import { render } from "./AdminDetailWindow.vue?vue&type=template&id=f6e1b592&scoped=true"
import script from "./AdminDetailWindow.vue?vue&type=script&lang=js"
export * from "./AdminDetailWindow.vue?vue&type=script&lang=js"

import "./AdminDetailWindow.vue?vue&type=style&index=0&id=f6e1b592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e1b592"]])

export default __exports__